<template>
	<div>
		<div class="container">
			<div class="infoContain">
				<div>
					<ValidationObserver v-slot="{ handleSubmit }">
						<form class="infoBoxForm" @submit.prevent="handleSubmit(onClickNextBtn)">
							<div class="article">
								<div class="article-title">
									<h3>네트워킹 정보</h3>
								</div>
								<div class="middle-title">
									<h4 class="fs24">회사 소개</h4>
								</div>
								<div class="flex mobileFlex customRow">
									<ValidationProvider
										class="inputBox infoBox"
										name="시도"
										rules="required"
										v-slot="{ errors }"
									>
										<label>최종학력</label>
										<div class="bspSelectBox">
											<b-form-select v-model="signupInfo.education" class="custom-select">
											<option value="">최종학력을 선택하세요.</option>
											<option value="0">고졸 이하</option>
											<option value="1">대학교 졸</option>
											<option value="2">대학원 석사 이상</option>
											</b-form-select>
										</div>
										<span class="notValidationTxt">{{ errors[0] }}</span>
									</ValidationProvider>
									<div class="inputBox infoBox">
										<label>최종학교명</label>
										<input
											v-model="signupInfo.school"
											placeholder="최종 학교명을 입력하세요."
											type="text"
											class="input-grey"
										/>
									</div>
								</div>

								<h4 class="fs24 mt-4">경력 정보</h4>
								<template v-if="signupInfo.careers && signupInfo.careers.length > 0">
									<div
										v-for="(item, index) in signupInfo.careers"
										:key="index"
										class="rowTime inputBox infoBox"
									>
										<div class="flex mobileFlex flexAlignC">
											<div>
												<label v-if="index === 0" for="" class="inputBox__label">기간</label>
												<div class="flex flexAlignC">
													<div class="rowTime__stt">
														<i class="ic ic--arrow-down"></i>
													</div>
													<div class="rowTime__time">
														<div class="flex flexAlignC">
															<date-picker
																class="input-grey"
																v-model="signupInfo.careers[index].careerPeriodFrom"
																:config="optionsDate"
															></date-picker>
															<i class="ic ic--line"></i>
															<date-picker
																class="input-grey"
																v-model="signupInfo.careers[index].careerPeriodTo"
																:config="optionsDate"
															></date-picker>
														</div>
													</div>
												</div>
											</div>
											<div class="rowTime__input">
												<label v-if="index === 0" for="" class="inputBox__label">경력 사항</label>
												<div class="flex flexAlignC">
													<input
														v-model="signupInfo.careers[index].name"
														placeholder="최종 학교명을 입력하세요."
														type="text"
														class="input-grey"
													/>
													<div class="checkBoxItem">
														<div class="flex flexAlignC"></div>
														<input
															v-model="signupInfo.careers[index].inOffice"
															:id="'careersinOffice' + index"
															type="checkbox"
															value="1"
														/>
														<label :for="'careersinOffice' + index" style="white-space: nowrap">
															재직중
														</label>
													</div>
													<div class="rowTime__input">
														<button
															v-if="index != 0"
															class="btn-icon btn-gray"
															@click.prevent="removeRowDate(index)"
														>
															<i class="ic ic--minus-white"></i>
														</button>
														<button v-else class="btn-icon" @click.prevent="addRowDate">
															<i class="ic ic--plus"></i>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
							</div>

							<div class="article">
								<div class="middle-title">
									<h4 class="fs24">자기소개</h4>
								</div>

								<div class="inputBox infoBox">
									<label>나의 소개</label>
									<textarea
										class="input-grey"
										v-model="signupInfo.aboutMe"
										placeholder="나에 대한 간략한 소개를 입력하세요."
									></textarea>
								</div>
							</div>

							<div class="article">
								<div class="article-title">
									<h4>매치메이킹 희망분야</h4>
								</div>
								<div class="article-explain">
									<h5>
										귀하가 관심있고 네트워킹하고 싶은 시니어산업의 세부산업을
										선택해주십시오.(복수선택 가능)
									</h5>
								</div>
								<div class="flex mobileFlex">
									<div class="select-content">
										<div v-for="(industry, index) in age_friendly_industry" :key="industry.value">
											<div class="checkBoxItem">
												<input
													v-model="industry.isChecked"
													type="checkbox"
													:id="'industryCheckbox' + industry.value + '_' + index"
													:value="industry.value"
												/>
												<label :for="'industryCheckbox' + industry.value + '_' + index">
													고령친화{{ industry.name }}
												</label>
											</div>
											<template v-if="industry.isChecked">
												<div class="">
													<SelectMultipleOption
														v-model="industry.categoryIds"
														:options="industry.sectors"
														placeholder="업종을 선택해주세요."
													>
													</SelectMultipleOption>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>

							<div class="article">
								<div class="article-title">
									<h4>매치메이킹 희망활동</h4>
								</div>
								<div class="article-explain">
									<h5>
										매치메이킹을 통해 도움받고자 하는 항목을 선택 후, 구체적인 내용을
										적어주십시오.(복수선택 가능)
									</h5>
								</div>
								<div class="flex mobileFlex">
									<div class="select-content">
										<div v-for="(activity, index) in hope_activity" :key="index">
											<div class="checkBoxItem">
												<input
													v-model="activity.isChecked"
													type="checkbox"
													:id="'activityCheckbox' + activity.value + '_' + index"
													:value="activity.value"
												/>
												<label :for="'activityCheckbox' + activity.value + '_' + index">
													{{ activity.name }}
												</label>
											</div>
											<div v-if="activity.isChecked" class="inputBox mt-3">
												<input
													v-model="activity.content"
													placeholder="도움 받고자 하는 내용을 구체적으로 입력하세요."
													type="text"
													class="input-grey"
												/>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="btnBox flex topPd">
								<button type="button" class="btnFont redborderBtn" @click="onClickBeforeBtn">
									이 전
								</button>
								<button type="submit" class="btnFont redBtn">다 음</button>
							</div>
						</form>
					</ValidationObserver>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { ageFriendlyIndustry, hopeActivity , sidoList} from '@/data/constances'
import { signinJoinInfoNetworkingWriteUsrMinix } from '@/mixins/signin-mixins'
import moment from 'moment'
import SelectMultipleOption from '@/components/formControl/SelectMultipleOption.vue'

export default {
	name: 'JoinInfoNetworkingWriteUsr',
	components: {
		ValidationObserver,
		ValidationProvider,
		SelectMultipleOption,
	},
	mixins: [signinJoinInfoNetworkingWriteUsrMinix],
	data() {
		const formatDate = 'DD/MM/YYYY'
		return {
			optionsDate: {
				format: formatDate,
				useCurrent: false,
			},
			signupInfo: {
				roleName: this.$role.USER,
				education: 0,
				school: '',
				aboutMe: '',
				careers: [
					{
						careerPeriodFrom: moment().format(formatDate),
						careerPeriodTo: moment().format(formatDate),
						name: '',
						inOffice: 0,
					},
				],
				industries1: [],
				activities: [],
			},
			age_friendly_industry: ageFriendlyIndustry.map((item) => ({
				...item,
				categoryIds: [],
				selected: [],
			})),
			hope_activity: hopeActivity,
			sidoList : [
				{value: null, text: '최종학력을 선택하세요.'},
				{value: '0', text: '고졸 이하'},
				{value: '1', text: '대학교 졸'},
				{value: '2', text: '대학원 석사 이상'},
			]
		}
	},
	computed: {
		selectedIndustryData() {
			return this.age_friendly_industry
				.filter((item) => item.isChecked)
				.map((item) => ({
					categoryIds: item.categoryIds,
					categoryIndustryId: item.value,
				}))
		},
		selectedActivityData() {
			return this.hope_activity
				.filter((item) => item.isChecked)
				.map((item) => ({
					activityId: item.value,
					content: item.content,
				}))
		},
	},
	methods: {
		onClickBeforeBtn() {
			const formatDate = 'DD/MM/YYYY'
			this.signupInfo = {
				roleName: this.$role.USER,
				education: 0,
				school: '',
				aboutMe: '',
				careers: [
					{
						careerPeriodFrom: moment().format(formatDate),
						careerPeriodTo: moment().format(formatDate),
						name: '',
						inOffice: 0,
					},
				],
				industries1: [],
				activities: [],
			}

			this.setCurrentTab(2)
		},

		onClickNextBtn() {
			const signupInfo = {
				...this.getSignupForm,
				...this.signupInfo,
				careers: this.signupInfo.careers.map((item) => ({
					...item,
					inOffice: item.inOffice ? 1 : 0,
				})),
				industries1: this.lodash.values(this.selectedIndustryData),
				activities: this.lodash.values(this.selectedActivityData),
			}

			this.signup(signupInfo)
				.then(() => {
					this.setCompletedInfo({
						id: signupInfo.id,
						name: signupInfo.name,
						phoneNumber: signupInfo.phoneNumber,
					})
					this.setCurrentTab(4)
				})
				.catch((error) => {
					console.error(error);
					var data = error?.response?.data || {}
					switch (data.ERROR) {
						case 'ALREADY_EXIST_ID':
							this.$alert('알림', '사용중인 아이디 입니다.')
							break
						case 'ALREADY_EXIST_EMAIL':
							this.$alert('알림', '사용중인 이메일 입니다.')
							break
						case 'ALREADY_EXIST_PHONE_NUMBER':
							this.$alert('알림', '사용중인 전화번호 입니다.')
							break
						default:
							this.$alert('알림', '요청 실패')
							break
					}
				})
		},
		addRowDate() {
			this.signupInfo.careers.push({
				careerPeriodFrom: '',
				careerPeriodTo: '',
				name: '',
				inOffice: 0,
			})
		},
		removeRowDate(index) {
			this.signupInfo.careers.splice(index, 1)
		},
	},
}
</script>

<style scoped lang="scss">
.rowTime ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
}
.checkBoxForm ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
	@import '~bootstrap-vue/dist/bootstrap-vue.min';
}
.bspRadio ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
}
.bspSelectBox ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
	@import '~bootstrap-vue/dist/bootstrap-vue.min';
}
</style>

<style scoped lang="css">
.article {
	position: relative;
	margin-bottom: 56px;
}

.article::after {
	position: absolute;
	content: '';
	bottom: -14px;
	left: 0;
	width: 100%;
	height: 1px;
	background: #e7e7e7;
}
.textAreaBox {
	width: 100%;
	margin-bottom: 32px;
}
.textAreaBox p {
	display: none;
}
.middle-title {
	margin-bottom: 24px;
}
.textAreaBox textarea {
	width: 100%;
	background: #fdfcfc;
	border: 1px solid #e7e7e7;
	font-size: 20px;
	color: #000000;
	padding: 10px;
	min-height: 80px;
	resize: none;
	overflow: auto;
	font-family: 'Noto Sans KR';
	font-weight: 500;
}
.article-title {
	padding-bottom: 24px;
}

.select-content {
	width: 100%;
}
.select-content > div {
	margin: 18px 0;
}
.checkBoxItem {
	display: flex;
	align-items: center;
}
.checkBoxItem label {
	font-size: 20px;
	margin-left: 12px;
}
.checkBoxItem input {
	width: 22px;
	height: 22px;
}
.checkBoxItem ~ div > select {
	width: 100%;
	height: 45px;
	border: 1px solid #272727;
	font-size: 20px;
	color: #7d7d7d;
	font-weight: 500;
	margin: 13px 0 6px;
}
.checked-sectors-name-btn {
	background: #f3f3f3;
	border-radius: 6px;
	padding: 10px 16px;
	display: flex;
	align-items: center;
	width: fit-content;
}
.checked-sectors-name-btn button {
	margin-left: 10px;
	background: none;
	border: none;
	outline: none;
	display: flex;
	align-items: center;
}
.checked-sectors-name-btn button img {
	width: 20px;
	height: 20px;
}
</style>
